import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

const Home = lazy(() => import('./home/home.component'));
const ShopActivity = lazy(() => import('./activity/activity.component'));
const OrderDetail = lazy(() => import('./orders/order-detail/order-detail.component'));

export function ShopRoutes() {
    return (
        <Route path='shop'>
            <Route
                index
                element={<Navigate to='home' />}
            />
            <Route path='home'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <Home />
                        </AsyncComponent>
                    }
                />
            </Route>
            <Route
                path='activities'
                element={
                    <AsyncComponent>
                        <ShopActivity />
                    </AsyncComponent>
                }
            />
            <Route
                path='orders'
                element={
                    <Navigate
                        to='/shop/activities'
                        replace
                    />
                }
            />
            <Route
                path='orders/:orderId'
                element={
                    <AsyncComponent>
                        <OrderDetail />
                    </AsyncComponent>
                }
            />
        </Route>
    );
}
